/**
 * Component Registry for Weidner Apartment Homes Theme
 * 
 * Extends the base avenue theme registry with Weidner Apartment Homes specific overrides.
 */

import type { ComponentRegistry } from '@vibesites/runtime';
import { registry as baseRegistry } from '@vibesites/theme-avenue/registry';
import { CortFurnishButton } from './components/CortFurnishButton';
import { CTASection } from './components/CTASection';
import { FutureResidentsClub } from './components/FutureResidentsClub';
import { Footer } from './components/Footer';
import { Header } from './components/Header';
import { Navigation } from './components/Navigation';
import { NeighborhoodCallout } from './components/NeighborhoodCallout';
import { NeighborhoodMap } from './components/NeighborhoodMap';
import { PageHero } from './components/PageHero';
import { PricingVerbiage } from './components/PricingVerbiage';
import { PropertyOverview } from './components/PropertyOverview';
import { FloorplansList } from './components/FloorplansList';
import { ReviewsCallout } from './components/ReviewsCallout';

const weidnerapartmenthomesOverrides: Partial<ComponentRegistry> = {
  CortFurnishButton,
  CTASection,
  FloorplansList,
  FutureResidentsClub,
  Footer,
  Header,
  Navigation,
  NeighborhoodCallout,
  NeighborhoodMap,
  PageHero,
  PricingVerbiage,
  PropertyOverview,
  ReviewsCallout,
};

/**
 * Final merged registry for Weidner Apartment Homes properties.
 * Inherits all components from the avenue theme, with Weidner Apartment Homes overrides.
 */
export const registry: ComponentRegistry = {
  ...baseRegistry,
  ...weidnerapartmenthomesOverrides,
};

export default registry;
